import firebase from 'firebase'
import { ref } from 'constants/firebase'
import { uploadImageSimple, removeFromStorageSimple } from './storage'
import * as _ from 'lodash'

export function addProduct (appId, info, files) {
  return function * (dispatch, getState) {
    // console.log('controllers addProduct', appId, info, files)
    const state = getState()
    const userId = state.authData.id
    const productInfo = {
      ...info,
      createdTime: firebase.database.ServerValue.TIMESTAMP
    }
    // console.log('productInfo', productInfo)
    yield ref.child('users').child(userId).child('apps').child(appId).child('customFields/productsDict').child(info.id).set(productInfo)
    const assets = yield _.map(files, file => uploadImageSimple(userId, file))
    // console.log('assets', assets)
    ref.child('users').child(userId).child('apps').child(appId).child('customFields/productsDict').child(info.id).child('assets').set(assets)
  }
}

export function updateProduct (appId, info, files, deleteAssets) {
  return function * (dispatch, getState) {
    // console.log('controllers addProduct', appId, info, files)
    const state = getState()
    const userId = state.authData.id
    const productInfo = {
      ...info
    }
    // console.log('productInfo', productInfo)
    yield ref.child('users').child(userId).child('apps').child(appId).child('customFields/productsDict').child(info.id).update(productInfo)
    const assets = yield _.map(files, file => {
      if (_.has(file, ['url'])) {
        return file
      } else {
        return uploadImageSimple(userId, file)
      }
    })
    // console.log('assets', assets)
    ref.child('users').child(userId).child('apps').child(appId).child('customFields/productsDict').child(info.id).child('assets').set(assets)
    yield _.map(deleteAssets, asset => removeFromStorageSimple(userId, appId, asset.id))
  }
}



// WEBPACK FOOTER //
// ./src/controllers/products.js